package org.example.project.screens_sys

import org.example.project.utils.All

private val HIDDEN_SYSTEM_COMPANY_IDS = setOf("ls1000", "ls2000")

internal fun List<All>.withoutInternalSystemCompanies(): List<All> =
    filterNot { it.isInternalSystemCompany() }

private fun All.isInternalSystemCompany(): Boolean =
    sequenceOf(id, firmenId)
        .map { it.trim().lowercase() }
        .any { it in HIDDEN_SYSTEM_COMPANY_IDS }
